export default "__VITE_ASSET__BLU4rpqv__"